export const getChannelsQuery = `
  {
    allChannels{
      id
      name
      description
    }
  }`;
